<template>
  <div class="row">
    <div class="col-12 form-group form-group-sm">
      <label class="label" for="vehiculo">VENTA</label>
      <div class="card">
        <div class="card-body">
          <div class="container">
            <div class="row">
              <div
                class="col-12 col-md-3 form-group form-group-sm d-flex align-items-center"
              >
                <input
                  id="tieneVendedor"
                  v-model="tieneVendedor"
                  class="form-check-inline"
                  type="checkbox"
                  style="zoom: 1.5"
                />
                <label class="label" for="tieneVendedor">
                  Alta por vendedor
                </label>
              </div>
            </div>
            <template v-if="tieneVendedor">
              <div class="row">
                <SelectVendedor />
              </div>
              <div class="row">
                <div class="col-12 form-group form-group-sm">
                  <label class="label" for="notas">Notas</label>
                  <textarea
                    id="notas"
                    v-model="ventaNotas"
                    :class="`form-control form-control-sm text-center bg-white`"
                    style="cursor: text"
                    type="text"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectVendedor from "@/pages/Clientes/Contratos/Crear/SelectVendedor";

export default {
  name: "VentaForm",
  props: ["value"],
  data: () => ({
    tieneVendedor: false,
  }),
  components: { SelectVendedor },
  computed: {
    ventaNotas: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
